import { createApi } from '@reduxjs/toolkit/query/react';
import { normalizeGroups } from 'features/Integrations/utils/integrationNormalize';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const groupsApi = createApi({
  reducerPath: 'groupsApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['DeviceGroups'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    GetGroups: builder.query({
      query: () => ({
        url: '/v2/integrations/device-group',
      }),
      transformResponse: (response) => normalizeGroups(response?.result),
      providesTags: ['DeviceGroups'], // Tells RTK Query this query provides 'Device' data and to refetch when invalidated
    }),
    createGroup: builder.mutation({
      query: (group) => ({
        url: '/v2/integrations/device-group',
        method: 'POST',
        data: { group },
      }),
      invalidatesTags: ['DeviceGroups'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    editGroup: builder.mutation({
      query: (group) => ({
        url: `/v2/integrations/device-group/${group.id}`,
        method: 'PATCH',
        data: { group },
      }),
      invalidatesTags: ['DeviceGroups'], // Tells RTK Query to refetch any queries that provide this tag
    }),
    deleteGroup: builder.mutation({
      query: (id) => ({
        url: `/v2/integrations/device-group/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['DeviceGroups'], // Tells RTK Query to refetch any queries that provide this tag
    }),
  }),
});

export const {
  useGetGroupsQuery,
  useCreateGroupMutation,
  useEditGroupMutation,
  useDeleteGroupMutation,
} = groupsApi;
